import { parseAsString, useQueryStates } from 'nuqs'
import { useCallback, useMemo } from 'react'
import type { AgentRunsFilters } from '~/entities/document-agent'
import { getDefaultDateRange, isCalendarDate } from '../lib'

export type AgentRunsFiltersUpdate = {
  dateFrom?: string | null
  dateTo?: string | null
  runLabel?: string
}

export function useAgentRunsFilters() {
  const defaults = useMemo(() => getDefaultDateRange(), [])
  const [params, setParams] = useQueryStates({
    from: parseAsString,
    to: parseAsString,
    label: parseAsString.withDefault(''),
  })

  const filters = useMemo<AgentRunsFilters>(
    () => ({
      dateFrom: isCalendarDate(params.from) ? params.from : defaults.dateFrom,
      dateTo: isCalendarDate(params.to) ? params.to : defaults.dateTo,
      runLabel: params.label,
    }),
    [params, defaults],
  )

  const updateFilters = useCallback(
    (next: AgentRunsFiltersUpdate) => {
      // nuqs serializes every key it is given, so absent keys must stay absent.
      const update: { from?: string | null; to?: string | null; label?: string | null } = {}
      if (next.dateFrom !== undefined) update.from = next.dateFrom
      if (next.dateTo !== undefined) update.to = next.dateTo
      if (next.runLabel !== undefined) update.label = next.runLabel || null
      setParams(update)
    },
    [setParams],
  )

  return { filters, updateFilters }
}
